import { State } from 'app/redux';

export const getAuth = (state: State) => state.auth;
